import {
  ID,
  LinkedItemSection,
  SortingMode,
  Task,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { buildSectionTree } from '@griply/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type Options = {
  tasks: Task[];
  sections?: LinkedItemSection[] | null;
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  showEmptyGroups?: boolean;
  hideNewTaskRow?: boolean;
};

export const useSectionTree = ({
  tasks,
  sections = [],
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  showEmptyGroups,
  hideNewTaskRow,
}: Options) => {
  const { t } = useTranslation();
  const noSectionLabel = t('general.labels.goal.sections.other.label');

  return useMemo<Record<ID, TaskListTreeItem>>(
    () =>
      buildSectionTree({
        tasks,
        sections,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        showEmptyGroups,
        hideNewTaskRow,
        noSectionLabel,
        rootLabel: 'Root',
        newTaskLabel: 'New Task',
      }),
    [
      sections,
      customOrder,
      sortingMode,
      tasks,
      today,
      weekStartsOn,
      showEmptyGroups,
      hideNewTaskRow,
      noSectionLabel,
    ],
  );
};
